<script>
import { assoc, pick, pipe } from 'rambda'
import SelectArchArticle from './SelectArchArticle'
import { actions } from '@utils'

export default {
  components: {
    SelectArchArticle,
  },
  data() {
    return {
      isSettingArchArticle: false,
    }
  },
  methods: {
    setArchArticle(articleId) {
      return this.$wrap(
        async () => {
          this.upArticle(['archArticleId'], articleId)

          if (!articleId) return

          const articleLaptops = await this
            .FIND_ARTICLE_LAPTOP({ articleId })

          this.setArticleLaptops(articleLaptops
            .map(pipe(
              pick([
                'alternativeToLaptopId',
                'cons',
                'description',
                'laptopId',
                'position',
                'pros',
                // 'subtitle',
              ]),
              assoc(
                'articleId',
                this.article.id,
              )),
            ))
        },
        'isSettingArchArticle',
      )
    },
    ...actions('FIND_ARTICLE_LAPTOP'),
  },
  render: () => '',
}
</script>
